/**
 * Combines existing sets with additional priority sets
 * Priority sets are added at the beginning in the order they are provided
 * @param sets - The existing sets array
 * @param prioritySets - Additional sets to add at the beginning (optional)
 * @returns Combined array of sets with priority sets first
 */
export const combineWithPrioritySets = (
  sets: Gallery.Models.Url.JSONObject[],
  ...prioritySets: (Gallery.Models.Url.JSONObject | undefined)[]
): Gallery.Models.Url.JSONObject[] => {
  const setsToAdd: Gallery.Models.Url.JSONObject[] = []

  for (const set of prioritySets) {
    if (set && Object.keys(set).length > 0) {
      setsToAdd.push(set)
    }
  }

  return [...setsToAdd, ...sets]
}
